/**
 * Tomaruba Guest API
 * Tomaruba Guest API
 *
 * OpenAPI spec version: 1.0.0
 * Contact: development@tomaruba.me
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient'

/**
 * The Hotel model module.
 * @module model/Hotel
 * @version 1.0.0
 */
export default class Hotel {
  /**
   * Constructs a new <code>Hotel</code>.
   * @alias module:model/Hotel
   * @class
   */

  constructor() {}

  /**
   * Constructs a <code>Hotel</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/Hotel} obj Optional instance to populate.
   * @return {module:model/Hotel} The populated <code>Hotel</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new Hotel()

      if (data.hasOwnProperty('id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Number')
      }
      if (data.hasOwnProperty('name')) {
        obj['name'] = ApiClient.convertToType(data['name'], 'String')
      }
      if (data.hasOwnProperty('closed_date')) {
        obj['closed_date'] = ApiClient.convertToType(data['closed_date'], 'Date')
      }
      if (data.hasOwnProperty('terms_url')) {
        obj['terms_url'] = ApiClient.convertToType(data['terms_url'], 'Blob')
      }
    }
    return obj
  }

  /**
   * @member {Number} id
   */
  id = undefined
  /**
   * @member {String} name
   */
  name = undefined
  /**
   * @member {Date} closed_date
   */
  closed_date = undefined
  /**
   * @member {Blob} terms_url
   */
  terms_url = undefined
}
